import React, { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import HandleDateTime from "../../../../Common/HandleDateTime";
import DeleteModal from "../../../../Common/DeleteModal";
import TableContainer from "../../../../Common/TableContainer";
import AddEditSecurityRole from "../../../../popUpComponents/AddEditSecurityRole";
import RequestMissingPermission from "../../../../popUpComponents/RequestMissingPermission";
import {
  deleteSecurityAuthRole,
  deleteSecurityAuthRoleSuccess,
  getSecurityAuthRoleById,
  getSecurityAuthRoleList,
} from "../../../../../store/security/action";

export default function SecurityLists({ page, data, reportName }) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{card.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },

      {
        // job id  with beginning #Job_Id
        Header: "Name",
        accessor: "Name",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 name">{card.row.original?.Name}</div>
            </div>
          </>
        ),
      },

      // Notes

      {
        Header: "Notes",
        accessor: "Notes",
        Cell: (row) => {
          return (
            <div className={"text-wrap"} style={{ maxWidth: "350px" }}>
              {row.row.original?.Notes}
            </div>
          );
        },
      },
      {
        Header: "Created Date",
        accessor: "CreatedDateTime",
        Cell: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row.row.original?.CreatedDateTime)}</div>;

          // return row.CreatedDateTime
        },
        filterable: true,
      },
      //action edit delete
      {
        Header: "Action",
        accessor: "action",
        Cell: (row) => {
          return (
            <div>
              <UncontrolledDropdown>
                <DropdownToggle
                  className="btn btn-soft-info btn-icon fs-14"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fa-solid fa-ellipsis"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <li>
                    <DropdownItem>
                      <div
                        className="edit-item-btn"
                        onClick={() => {
                          handleGetUpdateDetails(row.row.original?.Id);
                        }}
                      >
                        <div className={"job-settings-buttons"}>
                          <i className="ri-pencil-fill align-center text-muted"></i>
                          <span> Edit</span>
                        </div>
                      </div>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem>
                      <div
                        className="remove-item-btn"
                        onClick={() => {
                          setSelectForDelete([row.row.original?.Id]);
                          setDeleteModal(true);
                        }}
                      >
                        <div className={"job-settings-buttons"}>
                          <i className="ri-delete-bin-fill align-center text-muted"></i>{" "}
                          <span> Delete</span>
                        </div>
                      </div>
                    </DropdownItem>
                  </li>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        },
      },
    ],
    [searchResults]
  );
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Notes",
    "Name",
    "Description",
  ]);
  useEffect(() => {
    let filteredCustomerList = data;

    const timer = setTimeout(() => {
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters?.some((key) => {
          return (
            item[key] &&
            item[key]
              ?.toString()
              ?.toLowerCase()
              ?.includes(search?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, data]);

  const [modalAddEdit, setModalAddEdit] = useState(false);
  const toggleAddEdit = () => setModalAddEdit(!modalAddEdit);

  const [modalRequestPermission, setModalRequestPermission] = useState(false);
  const toggleRequestPermission = () =>
    setModalRequestPermission(!modalRequestPermission);

  const [isEdit, setIsEdit] = useState(false);
  const handleCreateEdit = (type) => {
    if (type === "create") {
      setIsEdit(false);
    } else {
      setIsEdit(true);
    }
    toggleAddEdit();
  };
  const handleGetUpdateDetails = (id) => {
    switch (reportName) {
      case "securityRoleList":
        dispatch(getSecurityAuthRoleById({ id }));
        handleCreateEdit("edit");
        break;

      default:
        break;
    }
  };
  const { securityAuthRoleByIdAPI } = useSelector((state) => ({
    securityAuthRoleByIdAPI:
      state.Security.securityAuthRoleById?.securityauthrole_data,
  }));

  const [selectForDelete, setSelectForDelete] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDeleteSingleRecord = () => {
    switch (reportName) {
      case "securityRoleList":
        dispatch(deleteSecurityAuthRole(selectForDelete));
        break;

      default:
    }
  };

  const { securityAuthRoleDeleteSuccessAPI } = useSelector((state) => ({
    securityAuthRoleDeleteSuccessAPI:
      state.Security.securityAuthRoleDeleteSuccess,
  }));

  useEffect(() => {
    if (isEmpty(securityAuthRoleDeleteSuccessAPI)) return;
    if (securityAuthRoleDeleteSuccessAPI?.status === 200) {
      toast.success(securityAuthRoleDeleteSuccessAPI?.message);
      dispatch(getSecurityAuthRoleList());
      setDeleteModal(false);
    } else {
      toast.error(securityAuthRoleDeleteSuccessAPI?.message);
    }
    dispatch(deleteSecurityAuthRoleSuccess([]));
  }, [securityAuthRoleDeleteSuccessAPI]);

  const handlePeriodDetails = () => {
    switch (reportName) {
      case "securityRoleList":
        return securityAuthRoleByIdAPI;

      default:
        break;
    }
  };
  return (
    <>
      <DeleteModal
        show={deleteModal}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
        onDeleteClick={() => {
          handleDeleteSingleRecord();
        }}
        customText={"Are you sure you want to delete this VAT Period?"}
        customButtonText={"Yes, Delete It!"}
      />
      {modalAddEdit && (
        <AddEditSecurityRole
          modal={modalAddEdit}
          setModal={setModalAddEdit}
          toggle={toggleAddEdit}
          isEdit={isEdit}
          updateDetails={handlePeriodDetails()}
          reportName={reportName}
        />
      )}
      {modalRequestPermission && (
        <RequestMissingPermission
          modal={modalRequestPermission}
          setModal={setModalRequestPermission}
          toggle={toggleRequestPermission}
        />
      )}
      <div className={"p-2 m-2"}>
        <Row className="g-4 align-items-center">
          <Col sm={3}>
            <div className="search-box">
              <Input
                // create search with jobs List Data
                type="search"
                className="form-control search"
                placeholder="Search for..."
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                value={search}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>
          <div className="col-sm-auto ms-auto">
            <div className="hstack gap-2">
              <button
                className="btn btn-soft-primary"
                onClick={toggleRequestPermission}
              >
                <i className="ri-lock-unlock-line align-bottom me-1"></i>
                Request a permission
              </button>
              <button
                className="btn btn-success"
                onClick={() => {
                  handleCreateEdit("create");
                }}
              >
                <i className="ri-add-line align-bottom me-1"></i>
                Add new Role
              </button>
            </div>
          </div>
        </Row>
        <div>
          <TableContainer
            columns={columns}
            data={searchResults || []}
            isGlobalFilter={false}
            isAddUserList={false}
            customPageSize={10}
            className="custom-header-css"
            divClass="table-responsive table-card mb-0"
            tableClass="align-middle  "
            theadClass="text-muted"
            // handleLeadClick={handleLeadClicks}
            isLeadsFilter={false}
          />
        </div>
      </div>
    </>
  );
}
